import { render } from "./AcademyPage.vue?vue&type=template&id=4ca9f36c"
import script from "./AcademyPage.vue?vue&type=script&lang=js"
export * from "./AcademyPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__